import { NavListRoot } from './NavList';

/* ============================================================================
   Menu lateral - lista de grupos. Visual novo.

   Substitui List/ListSubheader do MUI. O subtitulo do grupo:

   - fica em maiuscula pequena com tracking largo, como todos os rotulos de secao
     do sistema novo (cartoes, cabecalhos de tabela);
   - quando a sidebar esta colapsada ele nao vira `opacity: 0` (que mantinha a
     ALTURA e deixava um vao inexplicavel entre os grupos) - vira um TRACO curto,
     que continua separando os grupos com a largura que existe.
   ============================================================================ */

export default function NavSectionVertical({ navConfig = [], isCollapse = false, ...other }) {
  return (
    <nav {...other}>
      {navConfig?.map((group) => (
        <div key={group.subheader} className="px-2 pb-1">
          {isCollapse ? (
            <div className="mx-auto my-2 h-px w-6 bg-line" aria-hidden />
          ) : (
            <div
              /* Titulo de secao mais discreto: 10px, mais espacamento entre
                 letras e menos altura em volta. Ele e uma etiqueta de organizacao,
                 nao um item - competia em peso com os proprios itens. */
              className="px-1 pb-0.5 pt-2 text-[10px] font-bold uppercase tracking-[0.12em] text-faint"
              title={group.subheader}
            >
              {group.subheader}
            </div>
          )}

          <div className="space-y-0.5">
            {group.items?.map((list) => (
              <NavListRoot key={list.title} list={list} isCollapse={isCollapse} />
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
}
